import { defineComponent, h } from 'vue';
import { tooltip } from '@/ui/components/Tooltip';
import { Button } from '@/ui/components/Button';
import { useManageIssueModal } from '@/ui/components/issue/ManageIssuesModal/useManageIssueModal';
import { IssueRecord } from '@/entities/issue/v2';
import { VNodeData } from 'vue/types/vnode.d';

interface ManageIssuesButtonProps {
  issues: IssueRecord[];
}

export const ManageIssuesButton = defineComponent<ManageIssuesButtonProps>({
  name: 'ManageIssuesButton',
  props: ['issues'],
  setup(props, context) {
    const { getTooltipMessage, isButtonDisabled } = useManageIssueModal();

    // Since the table row is clickable (whenever we click on it we will
    // be redirected to the resource page) we need to stop the
    // propagation and prevent the default behavior which
    // push the user to a new page
    const onClick = (e: MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();

      context.emit('click');
    };

    return function render() {
      return tooltip({
        label: getTooltipMessage(props.issues),
        position: 'is-left',
      }, [
        h(Button, {
          class: {
            'manage-issues-button': true,
            'manage-issues-button--has-issues': props.issues.length > 0,
          },
          props: { type: 'is-light', disabled: isButtonDisabled(props.issues) },
          attrs: {
            iconRight: 'bullhorn',
            iconPack: 'far',
          },
          on: { click: onClick },
        }),
      ]);
    };
  },
});

export function manageIssuesButton(data: VNodeData & { props: ManageIssuesButtonProps }) {
  return h(ManageIssuesButton, data);
}
